<script>
  import { status, transactionServices } from "../../../config/transaction"

  export default {
    props: {
      filters: {
        default: null
      },
      excludes: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      transactionServices,
      serviceOptions() {
        return this.transactionServices.map((s) => ({ value: s, label: s.toUpperCase() }))
      },
      statusOptions() {
        return Object.values(status).map((s) => ({ value: s, label: s.toUpperCase()}))
      },
      filteredRanges: {
        get() {
          return this.queries.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
        },
        set(val) {
          this.queries.date = val.map((moment) => moment.format('YYYY-MM-DD'))
        }
      },
    },
    data: () => ({
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      queries: {
        q: '',
        page: 1,
        per_page: 10,
        date: [],
        status: [],
        billers: [],
        service: [],
        clients: [],
        products: []
      }
    }),
    methods: {
      autocomplete(v, iteratee) {
        if (v.length === 0) {
          this.queries[iteratee] = []
        } else {
          this.queries[iteratee] = _.map(v, (o) => o.id)
        }
      },
      submit() {
        this.$emit("filtered", this.queries)
      },
      reset() {
        this.queries = {
          page: 1,
          per_page: 10,
          q: '',
          clients: [],
          products: [],
          billers: [],
          service: [],
          status: [],
          date: []
        }

        this.submit()
      },
    },
    watch: {
      filters: {
        deep: true,
        immediate: true,
        handler: function(v) {
          if (v instanceof Object)
            Object.assign(this.queries, v)
        }
      }
    }
  }
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-form-model :model="queries" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="Keyword">
        <a-input placeholder="Keyword.." v-model="queries.q">
          <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-model-item>

      <a-form-model-item label="Date">
        <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
      </a-form-model-item>

      <a-form-model-item label="Status">
        <a-checkbox-group v-model="queries.status" :options="statusOptions" />
      </a-form-model-item>

      <a-form-model-item label="Service">
        <a-checkbox-group v-model="queries.service" :options="serviceOptions" />
      </a-form-model-item>

      <a-form-model-item label="Products" v-if="! excludes.includes('products')">
        <product-autocomplete style="width: 100%" @change="(item) => autocomplete(item, 'products') "/>
      </a-form-model-item>

      <a-form-model-item label="Clients" v-if="! excludes.includes('clients')">
        <client-autocomplete style="width: 100%" @change="(item) => autocomplete(item, 'clients') "/>
      </a-form-model-item>

      <a-form-model-item label="Billers" v-if="! excludes.includes('billers')">
        <biller-autocomplete style="width: 100%" @change="(item) => autocomplete(item, 'billers') "/>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 18, offset: 4}">
        <a-button type="primary" @click="submit" icon="filter">Filter</a-button>
        <a-button class="ml-2" icon="reload" @click="reset">Reset</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
